(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["styled-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.styled-list__modal a[href*="origo"]').forEach(a => {
    a.addEventListener('click', () => {
      try { localStorage.setItem('ski-test-flow', String(Date.now())); } catch (e) {}
    });
  });

  document.querySelectorAll('.modal-button').forEach(button => {
    const modalId = button.dataset.modalId;
    const modal = document.getElementById(modalId);

    button.addEventListener('click', () => modal.classList.add('active'));

    modal.querySelector('.modal-close').addEventListener('click', () => modal.classList.remove('active'));

    modal.querySelector('.modal-overlay').addEventListener('click', () => modal.classList.remove('active'));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        modal.classList.remove('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
